import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { CodeTypeDialogBoxComponent } from '../code-type-dialog-box/code-type-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-code-type-data',
  templateUrl: './code-type-data.component.html',
  styleUrls: ['./code-type-data.component.scss']
})
export class CodeTypeDataComponent implements OnInit {
  APIService: any;
  dialogRef: MatDialogRef<any>;
  CodeTypeSearchForm: FormGroup;
  codetypeList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder, 
    public router: Router, 
    private spinner: NgxSpinnerService) 
    { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.CodeTypeSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.getCodeTypeData();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getCodeTypeData();
    this.keypress();
  }

  getCodeTypeData() {
    this.spinner.show();
    const payload = {};
    payload["IsActive"] = "0";
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getCodeType(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.codetypeList = res.data; 
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.spinner.hide()
      }
     
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.spinner.show()
    let payload = {}
    payload['SearchString'] = this.CodeTypeSearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize; 
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.searchCodeType(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.codetypeList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.spinner.hide()
        this.codetypeList = [];
        this.totalItems = 0;
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.codetypeList = [];
    });
    },1000)
    
  }

  addnewrecord() { 
    const dialogRef = this.dialog.open(CodeTypeDialogBoxComponent, {
      width: '110vh',
      data: {key : "New"},
      disableClose: true   
    });  
    dialogRef.afterClosed().subscribe(result => {
      this.getCodeTypeData();
      this.CodeTypeSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k){
    const dialogRef = this.dialog.open(CodeTypeDialogBoxComponent, {
      width: '110vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
        this.getCodeTypeData(); 
        this.CodeTypeSearchForm.controls['SearchString'].setValue('');  
    });
  }

  deleteData(k){
    const dialogRef = this.dialog.open(CodeTypeDialogBoxComponent, {
      width: '110vh',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
        this.getCodeTypeData();      
        this.CodeTypeSearchForm.controls['SearchString'].setValue('');
    });
  }

}

